import React from 'react';
import { BarChart as RechartsBarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import './_charts.scss';

const BarChart = ({ data, title, dataKey, xAxisKey = 'category', color = '#007bff', height = 300 }) => {
  const toTitleCase = (text) => {
    if (typeof text !== 'string') return text;
    return text
      .replace(/_/g, ' ')
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const formatXAxis = (tickItem) => {
    return typeof tickItem === 'string' ? toTitleCase(tickItem) : tickItem;
  };

  const formatTooltip = (value, name) => {
    const prettyName = toTitleCase(name);
    if (name === 'revenue') {
      return [`${value.toLocaleString()} PKR`, 'Revenue'];
    }
    if (name === 'amount') {
      // Check if this is a currency amount, booking count, or percentage based on context
      if (value > 1000) {
        return [`${value.toLocaleString()} PKR`, 'Amount'];
      } else if (value <= 100 && value >= 0) {
        // Likely a percentage (occupancy rate)
        return [`${value}%`, 'Rate'];
      } else {
        return [`${value}`, 'Count'];
      }
    }
    if (name === 'percentage') {
      return [`${value}%`, 'Percentage'];
    }
    if (name === 'bookings_count') {
      return [`${value}`, 'Booking Count'];
    }
    return [value, prettyName];
  };

  return (
    <div className="chart-container">
      <h6 className="chart-title">{title}</h6>
      <ResponsiveContainer width="100%" height={height}>
        <RechartsBarChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis
            dataKey={xAxisKey}
            tickFormatter={formatXAxis}
            stroke="#666"
            fontSize={10}
            angle={-45}
            textAnchor="end"
            height={80}
          />
          <YAxis
            stroke="#666"
            fontSize={10}
            tickFormatter={(value) => `${value.toLocaleString()}`}
          />
          <Tooltip
            formatter={formatTooltip}
            contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #ccc',
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}
          />
          <Legend />
          <Bar
            dataKey={dataKey}
            fill={color}
            radius={[4, 4, 0, 0]}
            name={toTitleCase(dataKey)}
          />
        </RechartsBarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BarChart;
